import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { ApplicationStyles } from "../dto";

@Injectable({
  providedIn: "root"
})
export class ApplicationStylesService {
  private serviceUrl = "applicationStyles";
  constructor(private api: ApiService) {}

  getById(id: number): Observable<ApplicationStyles> {
    return this.api.get(`${this.serviceUrl}/` + id);
  }
  getDefault(): Observable<ApplicationStyles> {
    return this.api.get(`${this.serviceUrl}/default`);
  }
  getByPartnerId(partnerId: number): Observable<ApplicationStyles> {
    return this.api.get(`${this.serviceUrl}/partner/` + partnerId);
  }
  getByBrandId(brandId: number): Observable<ApplicationStyles> {
    return this.api.get(`${this.serviceUrl}/brand/${brandId}`);
  }

  add(applicationStyles: ApplicationStyles): Observable<ApplicationStyles> {
    return this.api.post(`${this.serviceUrl}`, applicationStyles);
  }

  update(id: number, applicationStyles: ApplicationStyles): Observable<ApplicationStyles> {
    return this.api.put(`${this.serviceUrl}/${id}`, applicationStyles);
  }

  updateBrandStyles(brandId: number, styles: ApplicationStyles): Observable<ApplicationStyles> {
    return this.api.put(`${this.serviceUrl}/brand/${brandId}`, styles);
  }

  delete(id: number): Observable<void> {
    return this.api.delete(`${this.serviceUrl}/${id}`);
  }
}
